import { messagesError } from "./messages.services";
import { DataResponse } from "../../shared/interface/data-response";
import { Rekognition } from "src/shared/interface/rekognition";
import { http } from './http.services';


/**
   * La función envía una foto para su análisis utilizando Rekognition y devuelve los datos de
   * respuesta.
   * @param {any} photo - El parámetro "photo" es el archivo de imagen que desea enviar para su
   * análisis. Puede estar en cualquier formato admitido por el servidor al que envía la solicitud.
   * @returns una Promesa que se resuelve en un objeto DataResponse de tipo Rekognition.
   */
const sendPhoto = async (photo: any): Promise<DataResponse<Rekognition>> =>{
  const formData = new FormData();
  formData.append("photo", photo);
  return http.Client(http.HeadersFormData.headers).post(`/photo-analysis/upload`, formData)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      messagesError(error);
      throw error;
    });
};

/**
   * La función `sendPhotoLote` es una función asincrónica que toma una serie de fotos y una ruta como
   * parámetros, y envía las fotos a un bucket de S3 para su análisis utilizando el servicio Rekognition.
   * @param {any} photos - El parámetro "fotos" es una matriz de objetos fotográficos. Cada objeto
   * fotográfico representa un archivo de imagen que desea enviar para su análisis.
   * @param {string} path - El parámetro `path` es una cadena que representa la ruta donde se cargarán
   * las fotos. Se utiliza en la URL de la solicitud POST para especificar la ruta de destino de las
   * fotos cargadas.
   * @returns una Promesa que se resuelve en un objeto DataResponse de tipo Rekognition.
   */
const  sendPhotoLote = async (photos: any, path: string): Promise<DataResponse<Rekognition>> => {
  const formData = new FormData();

  for (const photo of photos) {
    formData.append('photos[]', photo);
  }
  return http.Client(http.HeadersFormData.headers)
    .post(`/photo-analysis/multi-upload/${path}`, formData)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      messagesError(error);
      throw error; 
    });
}

export const Api = {
  sendPhoto,
  sendPhotoLote
}
